import { openDB } from 'idb';
const VALID_MODULES = ['material', 'category', 'collection', 'conservation', 'digital', 'museum', 'system', 'unit', 'location', 'user', 'group', 'role'];

// Initialize IndexedDB with multiple stores
export const initializeDB = async () => {
    const db = await openDB('my-database', 2, {
        upgrade(db, oldVersion, newVersion, transaction) {
            VALID_MODULES.forEach((module) => {
                if (!db.objectStoreNames.contains(module)) {
                    db.createObjectStore(module, { keyPath: 'id', autoIncrement: true });
                }
            });

        },
    });
    return db;
};

const validateModule = (moduleValue) => {
    if (!VALID_MODULES.includes(moduleValue)) {
        throw new Error(`Invalid moduleValue: ${moduleValue}. Must be one of ${VALID_MODULES.join(', ')}.`);
    }
};

// Add an item to a specific store
export const addItemToDB = async (values, moduleValue) => {
    validateModule(moduleValue);

    const db = await initializeDB();
    const tx = db.transaction(moduleValue, 'readwrite');
    await tx.objectStore(moduleValue).add(values);
    await tx.done;
};

// Clear all items from a specific store
export const clearPendingRequests = async (moduleValue) => {
    validateModule(moduleValue);

    const db = await initializeDB();
    const tx = db.transaction(moduleValue, 'readwrite');
    await tx.objectStore(moduleValue).clear();
    await tx.done;
};

// Get all items from a specific store
export const getPendingRequests = async (moduleValue) => {
    validateModule(moduleValue);

    const db = await initializeDB();
    const tx = db.transaction(moduleValue, 'readonly');
    const store = tx.objectStore(moduleValue);
    const items = await store.getAll();
    await tx.done;
    return items;
};
